import { render, staticRenderFns } from "./suggestion_block.vue?vue&type=template&id=13b29564"
import script from "./suggestion_block.vue?vue&type=script&lang=js"
export * from "./suggestion_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports